var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{attrs:{"icon":"mdi-arrow-collapse","title":_vm.$t('listing.matches.title')}}),_c('MatchesList',{staticClass:"mt-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }